import $ from "jquery";
import gsap from "gsap";
import Swiper from "swiper";
import "swiper/scss";

const $cursor = $(".js-slider-three-images__cursor");

const slideThreeImages = new Swiper(".slider-three-images__swiper", {
  slidesPerView: 1.6,
  spaceBetween: 20,
  grabCursor: true,
  breakpoints: {
    576: {
      slidesPerView: 1.9,
    },
    768: {
      slidesPerView: 2.15,
      spaceBetween: 32,
    },
    1240: {
      slidesPerView: 2.75,
      spaceBetween: 42,
    },
  },
  on: {
    touchMove: function (slideThreeImages, e) {
      gsap.to($cursor, {
        left: e.clientX,
        top: e.clientY,
      });
    },
  },
});

$(".js-swiper-slide").hover(
  function () {
    $cursor.show();
  },
  function () {
    $cursor.hide();
  },
);

$(".js-swiper-slide").on("mousemove", (e) => {
  gsap.to($cursor, {
    left: e.clientX,
    top: e.clientY,
  });
});
